/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Description_LabelInputs */



/**
* | output |
* | --- |
* | "Description/Title" |
*
* @param {Image_Export_Description_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_description_label = /** @type {((inputs?: Image_Export_Description_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Description_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description/Titre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschreibung/Titel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione/Titolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание/Название")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción/Título")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("描述/标题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("説明/タイトル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विवरण/शीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição/Título")
	return /** @type {LocalizedString} */ ("Description/Title")
});